<section class="hero">
  <div class="hero__inner">
    <div class="hero__content">
      @if (eyebrow) {
      <p class="hero__eyebrow">{{ eyebrow }}</p>
      }

      <h1 class="hero__title"
          [class.hero__title--with-logo]="!!brandLogoSrc">
        @if (brandLogoSrc) {
        <img class="hero__title-logo" [src]="brandLogoSrc" [alt]="brandLogoAlt" />
        }
        <span class="hero__title-text">{{ title }}</span>
      </h1>

      @if (subtitle) {
      <p class="hero__subtitle">{{ subtitle }}</p>
      }

      <div class="hero__actions">
        @if (primaryCtaLabel) {
        <a class="hero__button hero__button--primary"
           [routerLink]="primaryCtaLink"
           [fragment]="primaryCtaFragment || undefined">
          {{ primaryCtaLabel }}
        </a>
        }

        @if (secondaryCtaLabel) {
        <a class="hero__button hero__button--secondary"
           [routerLink]="secondaryCtaLink"
           [fragment]="secondaryCtaFragment || undefined">
          {{ secondaryCtaLabel }}
        </a>
        }
      </div>
    </div>
  </div>
</section>
